export default function inputMarksValidation (marks, lowerLimit, upperLimit) {
  if (marks === null) {
    return false
  } else if (marks < lowerLimit || marks > upperLimit) {
    return false
  } else {
    return true
  }
}
